import { rootApi } from '../rootApi';

export const vehicleDistributionReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleDistributionReport: builder.query({
            query: (body) => ({
                url: 'v1/VehicleDistributionReport/GetList',
                method: 'POST',
                body: {
                    pageSize: body?.pageSize ?? 10,
                    pageNumber: body?.pageNumber ?? 1,
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    includeFilterOptions: body?.includeFilterOptions ?? false,
                    filterOptionsColumns: body?.filterOptionsColumns ?? null
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['VehicleDistributionReport']
        }),
        exportVehicleDistributionToExcel: builder.query({
            query: (body) => ({
                url: 'v1/VehicleDistributionReport/ExportToExcel',
                method: 'POST',
                body: {
                    languageId: body?.languageId,
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    compressionType: body?.compressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export başarısız oldu');
            }
        })
    }),
    overrideExisting: false
});

export const { useGetVehicleDistributionReportQuery, useLazyExportVehicleDistributionToExcelQuery } = vehicleDistributionReportApi;
